import { render, staticRenderFns } from "./ItemAuthorActionsAsmtOptions.vue?vue&type=template&id=3065ecf0"
import script from "./ItemAuthorActionsAsmtOptions.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorActionsAsmtOptions.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorActionsAsmtOptions.vue?vue&type=style&index=0&id=3065ecf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports